import { Container } from "@fideus-ui/core";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod/v4";
import { TechnicalTab } from "../../../companies/technical/TechnicalTab";

const searchSchema = z.object({
  jahr: z.coerce.number().int().optional(),
});

export const Route = createFileRoute("/firmen/$companyId/technisch")({
  validateSearch: zodValidator(searchSchema),
  loader: async ({ params: { companyId }, context: { queryClient, trpc } }) => {
    void queryClient.ensureQueryData(
      trpc.companies.getCompany.queryOptions({ companyId })
    );
  },
  component: TechnischRoute,
});

function TechnischRoute() {
  const { companyId } = Route.useParams();
  const { jahr } = Route.useSearch();
  return (
    <Container>
      <TechnicalTab companyId={companyId} year={jahr} />
    </Container>
  );
}
